// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import { getFileType, getFileSize } from "src/utils/file";

import { Flex, HStack, Text } from "@chakra-ui/react";
import Icons from "src/icons";
import ProgressBar from "src/components/Dock/Checklist/File/ProgressBar";

import * as styles from "./styles";

type Props = {
  id: string,
  uploading: boolean,
  progress: number,
  name: string,
  size: number,
  removeItem: Function,
};

function Item({ id, uploading, progress, name, size, removeItem }: Props) {
  if (uploading) {
    return <ProgressBar progress={progress} />;
  }

  return (
    <Flex {...styles.container}>
      <HStack>
        <Icons type="fileIcons" icon={getFileType(name)} {...styles.fileIcon} />
        <Text {...styles.fileName}>{name}</Text>
        <Text {...styles.fileSize}>
          {i18n.t(k._1)}
          {getFileSize(size)}
          {i18n.t(k._2)}
        </Text>
      </HStack>

      <Icons
        handleClick={() => removeItem(id)}
        type="close"
        {...styles.removeIcon}
      />
    </Flex>
  );
}

export default Item;
